/* Asesor Línea Gráfica — chatbot público de lineagrafica.es (repo LINEA-GRAFICA/lg-chatweb). */
(function () {
  'use strict';
  var raiz = document.getElementById('lg-chatbot');
  if (!raiz || raiz.dataset.listo) return;
  raiz.dataset.listo = '1';

  var API = raiz.dataset.api;
  var INACTIVIDAD = 2 * 60 * 1000; // la sesión se cierra a los 2 min sin interacción
  var idioma = (raiz.dataset.idioma || document.documentElement.lang || 'es').slice(0, 2).toLowerCase();

  var TEXTOS = {
    es: { cupon: '¡Hola! 👋 Solo un recordatorio: con el cupón **ADDONS20** tienes un **20 % de descuento en módulos PrestaShop**. Si tienes cualquier duda sobre este módulo, pregúntame.', titulo: 'Asesor Línea Gráfica', estado: 'En línea', abrir: '¿Te ayudo?', hola: '¡Hola! Soy el asesor de Línea Gráfica. ¿En qué puedo ayudarte?', holaModulo: '¡Hola! ¿Qué necesitas resolver en tu tienda? Te ayudo a ver si este módulo es el adecuado.', ph: 'Escribe tu mensaje…', cerrada: 'Conversación cerrada por inactividad.', retomar: 'Retomar conversación', nueva: 'Empezar una nueva', anterior: 'Tienes una conversación anterior. ¿Seguimos donde lo dejamos?', error: 'Ahora mismo no puedo responder. Inténtalo en un momento o déjanos tus datos y te contactamos.', ocupado: 'Hay mucha gente consultando. Inténtalo en unos segundos.', bloqueo: 'Para seguir, déjanos tus datos y un especialista te contactará.', nombre: 'Nombre', email: 'Email', tel: 'Teléfono (opcional)', necesidad: '¿Qué necesitas?', enviar: 'Enviar', gracias: '¡Gracias! Un especialista te contactará muy pronto.', invalido: 'Revisa el nombre, el email y el mensaje.', legal: 'Asistente con IA. Puede cometer errores.', cerrar: 'Cerrar' },
    en: { cupon: 'Hi! 👋 Just a reminder: with the coupon **ADDONS20** you get **20% off PrestaShop modules**. If you have any question about this module, just ask.', titulo: 'Línea Gráfica Advisor', estado: 'Online', abrir: 'Need help?', hola: 'Hi! I am the Línea Gráfica advisor. How can I help you?', holaModulo: 'Hi! What do you need to solve in your store? I will help you check if this module fits.', ph: 'Type your message…', cerrada: 'Conversation closed due to inactivity.', retomar: 'Resume conversation', nueva: 'Start a new one', anterior: 'You have a previous conversation. Shall we pick up where we left off?', error: 'I cannot answer right now. Try again in a moment or leave us your details and we will contact you.', ocupado: 'Many people are asking right now. Try again in a few seconds.', bloqueo: 'To continue, leave us your details and a specialist will contact you.', nombre: 'Name', email: 'Email', tel: 'Phone (optional)', necesidad: 'What do you need?', enviar: 'Send', gracias: 'Thank you! A specialist will contact you shortly.', invalido: 'Please check your name, email and message.', legal: 'AI assistant. It may make mistakes.', cerrar: 'Close' },
    fr: { cupon: 'Bonjour ! 👋 Petit rappel : avec le code **ADDONS20**, vous avez **20 % de réduction sur les modules PrestaShop**. Une question sur ce module ? Demandez-moi.', titulo: 'Conseiller Línea Gráfica', estado: 'En ligne', abrir: 'Besoin d’aide ?', hola: 'Bonjour ! Je suis le conseiller de Línea Gráfica. Comment puis-je vous aider ?', holaModulo: 'Bonjour ! Que souhaitez-vous résoudre dans votre boutique ? Je vous aide à voir si ce module convient.', ph: 'Écrivez votre message…', cerrada: 'Conversation fermée pour inactivité.', retomar: 'Reprendre la conversation', nueva: 'En commencer une nouvelle', anterior: 'Vous avez une conversation précédente. On reprend là où on s’était arrêtés ?', error: 'Je ne peux pas répondre pour le moment. Réessayez ou laissez-nous vos coordonnées.', ocupado: 'Beaucoup de demandes en ce moment. Réessayez dans quelques secondes.', bloqueo: 'Pour continuer, laissez-nous vos coordonnées et un spécialiste vous contactera.', nombre: 'Nom', email: 'E-mail', tel: 'Téléphone (facultatif)', necesidad: 'De quoi avez-vous besoin ?', enviar: 'Envoyer', gracias: 'Merci ! Un spécialiste vous contactera très bientôt.', invalido: 'Vérifiez le nom, l’e-mail et le message.', legal: 'Assistant IA. Il peut se tromper.', cerrar: 'Fermer' },
    de: { cupon: 'Hallo! 👋 Kleiner Hinweis: Mit dem Gutschein **ADDONS20** erhalten Sie **20 % Rabatt auf PrestaShop-Module**. Fragen zu diesem Modul? Fragen Sie mich.', titulo: 'Línea Gráfica Berater', estado: 'Online', abrir: 'Hilfe?', hola: 'Hallo! Ich bin der Berater von Línea Gráfica. Wie kann ich helfen?', holaModulo: 'Hallo! Was möchten Sie in Ihrem Shop lösen? Ich helfe Ihnen zu prüfen, ob dieses Modul passt.', ph: 'Nachricht schreiben…', cerrada: 'Unterhaltung wegen Inaktivität beendet.', retomar: 'Unterhaltung fortsetzen', nueva: 'Neue beginnen', anterior: 'Sie haben eine frühere Unterhaltung. Sollen wir dort weitermachen?', error: 'Ich kann gerade nicht antworten. Versuchen Sie es gleich noch einmal oder hinterlassen Sie Ihre Daten.', ocupado: 'Gerade viele Anfragen. Bitte in ein paar Sekunden erneut versuchen.', bloqueo: 'Hinterlassen Sie Ihre Daten, ein Spezialist meldet sich bei Ihnen.', nombre: 'Name', email: 'E-Mail', tel: 'Telefon (optional)', necesidad: 'Was brauchen Sie?', enviar: 'Senden', gracias: 'Danke! Ein Spezialist meldet sich in Kürze.', invalido: 'Bitte Name, E-Mail und Nachricht prüfen.', legal: 'KI-Assistent. Er kann Fehler machen.', cerrar: 'Schließen' },
    it: { cupon: 'Ciao! 👋 Un promemoria: con il coupon **ADDONS20** hai il **20% di sconto sui moduli PrestaShop**. Hai domande su questo modulo? Chiedimi pure.', titulo: 'Consulente Línea Gráfica', estado: 'Online', abrir: 'Serve aiuto?', hola: 'Ciao! Sono il consulente di Línea Gráfica. Come posso aiutarti?', holaModulo: 'Ciao! Cosa devi risolvere nel tuo negozio? Ti aiuto a capire se questo modulo fa per te.', ph: 'Scrivi il tuo messaggio…', cerrada: 'Conversazione chiusa per inattività.', retomar: 'Riprendi la conversazione', nueva: 'Iniziane una nuova', anterior: 'Hai una conversazione precedente. Riprendiamo da dove eravamo?', error: 'Al momento non posso rispondere. Riprova tra poco o lasciaci i tuoi dati.', ocupado: 'Molte richieste in questo momento. Riprova tra qualche secondo.', bloqueo: 'Per continuare, lasciaci i tuoi dati e uno specialista ti contatterà.', nombre: 'Nome', email: 'Email', tel: 'Telefono (facoltativo)', necesidad: 'Di cosa hai bisogno?', enviar: 'Invia', gracias: 'Grazie! Uno specialista ti contatterà a breve.', invalido: 'Controlla nome, email e messaggio.', legal: 'Assistente IA. Può commettere errori.', cerrar: 'Chiudi' },
    pl: { cupon: 'Cześć! 👋 Przypominamy: z kuponem **ADDONS20** masz **20% rabatu na moduły PrestaShop**. Masz pytania o ten moduł? Zapytaj mnie.', titulo: 'Doradca Línea Gráfica', estado: 'Online', abrir: 'Pomóc?', hola: 'Cześć! Jestem doradcą Línea Gráfica. W czym mogę pomóc?', holaModulo: 'Cześć! Co chcesz rozwiązać w swoim sklepie? Pomogę sprawdzić, czy ten moduł pasuje.', ph: 'Napisz wiadomość…', cerrada: 'Rozmowa zamknięta z powodu braku aktywności.', retomar: 'Wznów rozmowę', nueva: 'Zacznij nową', anterior: 'Masz poprzednią rozmowę. Kontynuujemy?', error: 'Nie mogę teraz odpowiedzieć. Spróbuj za chwilę lub zostaw dane kontaktowe.', ocupado: 'Dużo zapytań. Spróbuj za kilka sekund.', bloqueo: 'Aby kontynuować, zostaw dane, a specjalista się z Tobą skontaktuje.', nombre: 'Imię', email: 'E-mail', tel: 'Telefon (opcjonalnie)', necesidad: 'Czego potrzebujesz?', enviar: 'Wyślij', gracias: 'Dziękujemy! Specjalista wkrótce się skontaktuje.', invalido: 'Sprawdź imię, e-mail i wiadomość.', legal: 'Asystent AI. Może się mylić.', cerrar: 'Zamknij' },
    pt: { cupon: 'Olá! 👋 Só um lembrete: com o cupão **ADDONS20** tem **20% de desconto em módulos PrestaShop**. Alguma dúvida sobre este módulo? Pergunte-me.', titulo: 'Consultor Línea Gráfica', estado: 'Online', abrir: 'Precisa de ajuda?', hola: 'Olá! Sou o consultor da Línea Gráfica. Em que posso ajudar?', holaModulo: 'Olá! O que precisa de resolver na sua loja? Ajudo-o a ver se este módulo é o adequado.', ph: 'Escreva a sua mensagem…', cerrada: 'Conversa encerrada por inatividade.', retomar: 'Retomar conversa', nueva: 'Começar uma nova', anterior: 'Tem uma conversa anterior. Continuamos onde ficámos?', error: 'Neste momento não consigo responder. Tente daqui a pouco ou deixe os seus dados.', ocupado: 'Muitas consultas neste momento. Tente dentro de alguns segundos.', bloqueo: 'Para continuar, deixe os seus dados e um especialista entrará em contacto.', nombre: 'Nome', email: 'Email', tel: 'Telefone (opcional)', necesidad: 'De que precisa?', enviar: 'Enviar', gracias: 'Obrigado! Um especialista entrará em contacto em breve.', invalido: 'Verifique o nome, o email e a mensagem.', legal: 'Assistente com IA. Pode cometer erros.', cerrar: 'Fechar' },
    ro: { cupon: 'Bună! 👋 Doar o reamintire: cu cuponul **ADDONS20** ai **20% reducere la modulele PrestaShop**. Ai întrebări despre acest modul? Întreabă-mă.', titulo: 'Consilier Línea Gráfica', estado: 'Online', abrir: 'Te ajut?', hola: 'Bună! Sunt consilierul Línea Gráfica. Cu ce te pot ajuta?', holaModulo: 'Bună! Ce ai nevoie să rezolvi în magazinul tău? Te ajut să vezi dacă acest modul e potrivit.', ph: 'Scrie mesajul…', cerrada: 'Conversație închisă din cauza inactivității.', retomar: 'Reia conversația', nueva: 'Începe una nouă', anterior: 'Ai o conversație anterioară. Continuăm de unde am rămas?', error: 'Nu pot răspunde acum. Încearcă imediat sau lasă-ne datele tale.', ocupado: 'Multe cereri acum. Încearcă în câteva secunde.', bloqueo: 'Pentru a continua, lasă-ne datele și un specialist te va contacta.', nombre: 'Nume', email: 'Email', tel: 'Telefon (opțional)', necesidad: 'De ce ai nevoie?', enviar: 'Trimite', gracias: 'Mulțumim! Un specialist te va contacta în curând.', invalido: 'Verifică numele, emailul și mesajul.', legal: 'Asistent AI. Poate greși.', cerrar: 'Închide' }
  };
  var T = TEXTOS[idioma] || TEXTOS.es;

  // ---- cookies: la conversación se recuerda un año; la última actividad, para el cierre a 2 min ----
  function leeCookie(n) {
    var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function ponCookie(n, v, dias) {
    var d = new Date(Date.now() + dias * 864e5);
    document.cookie = n + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax; Secure';
  }
  function borraCookie(n) { document.cookie = n + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'; }
  var conv = leeCookie('lgchat_id');
  function actividad() { ponCookie('lgchat_ult', String(Date.now()), 1); programaCierre(); }
  function ultima() { return parseInt(leeCookie('lgchat_ult') || '0', 10); }

  // ---- markdown mínimo y seguro: se escapa todo y solo se crean negritas, listas y enlaces de la web ----
  function esc(s) { return s.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function enlaceSeguro(u) {
    try { var x = new URL(u, location.href); return /(^|\.)lineagrafica\.es$/.test(x.hostname) && x.protocol === 'https:' ? x.href : ''; } catch (e) { return ''; }
  }
  function md(texto) {
    var lineas = esc(texto).split('\n'), html = '', enLista = false;
    lineas.forEach(function (l) {
      l = l.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (_, t, u) {
          var ok = enlaceSeguro(u.replace(/&amp;/g, '&'));
          return ok ? '<a href="' + esc(ok) + '">' + t + '</a>' : t;
        });
      var item = l.match(/^\s*(?:[-*•]|\d+\.)\s+(.*)/);
      if (item) { if (!enLista) { html += '<ul>'; enLista = true; } html += '<li>' + item[1] + '</li>'; return; }
      if (enLista) { html += '</ul>'; enLista = false; }
      if (l.trim()) html += '<p>' + l + '</p>';
    });
    if (enLista) html += '</ul>';
    return html;
  }

  // ---- interfaz ----
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  var avatar = raiz.dataset.avatar;
  var lanzador = el('button', 'lgc-lanzador');
  lanzador.type = 'button';
  lanzador.setAttribute('aria-label', T.titulo);
  lanzador.innerHTML = '<img alt="" src="' + esc(avatar) + '"><span class="lgc-texto">' + esc(T.abrir) + '</span><span class="lgc-punto"></span>';
  var panel = el('div', 'lgc-panel');
  panel.hidden = true;
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', T.titulo);
  panel.innerHTML =
    '<div class="lgc-cabecera"><img alt="" src="' + esc(avatar) + '"><div><div class="lgc-nombre">' + esc(T.titulo) + '</div><div class="lgc-estado">' + esc(T.estado) + '</div></div>' +
    '<button type="button" class="lgc-cerrar" aria-label="' + esc(T.cerrar) + '">×</button></div>' +
    '<div class="lgc-mensajes" aria-live="polite"></div>' +
    '<form class="lgc-pie"><textarea rows="1" maxlength="1000" placeholder="' + esc(T.ph) + '"></textarea>' +
    '<button type="submit" aria-label="' + esc(T.enviar) + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M3.4 20.4 21 12 3.4 3.6 3.4 10l12.6 2-12.6 2z"/></svg></button></form>' +
    '<div class="lgc-legal">' + esc(T.legal) + '</div>';
  raiz.appendChild(lanzador);
  raiz.appendChild(panel);
  var lista = panel.querySelector('.lgc-mensajes');
  var form = panel.querySelector('.lgc-pie');
  var caja = form.querySelector('textarea');
  var botonEnviar = form.querySelector('button');

  // ---- acción ADDONS20 (solo con data-campana="addons20" en el snippet) ----
  // GA4: la web carga la etiqueta de Google por GTM, que lee los comandos gtag de dataLayer.
  var CAMPANA = raiz.dataset.campana === 'addons20', MODULO = raiz.dataset.modulo === '1';
  // Un solo evento, cupon_chatbot_ofrecido (via=pregunta|apertura), y la cookie lg_cupon_via
  // para que WHMCS sepa en el purchase que el cupón vino del chat.
  var ofrecido = false;
  function ofreceCupon(via) {
    if (ofrecido) return;
    ofrecido = true;
    ga('cupon_chatbot_ofrecido', { via: via });
    var d = new Date(Date.now() + 180 * 864e5);
    document.cookie = 'lg_cupon_via=chatbot_' + via + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax; Secure' +
      (/(^|\.)lineagrafica\.es$/.test(location.hostname) ? '; domain=.lineagrafica.es' : '');
  }
  function ga(nombre, extra) {
    var p = { cupon: 'ADDONS20', pagina_tipo: raiz.dataset.tipo || '', idioma: idioma };
    for (var k in extra) p[k] = extra[k];
    try {
      if (typeof window.gtag === 'function') window.gtag('event', nombre, p);
      else { window.dataLayer = window.dataLayer || []; (function () { window.dataLayer.push(arguments); })('event', nombre, p); }
    } catch (e) {}
  }
  function cuponVisto() {
    try { if (localStorage.getItem('lgchat_addons20')) return true; } catch (e) {}
    return !!leeCookie('lgchat_addons20');
  }
  function marcaCupon() {
    try { localStorage.setItem('lgchat_addons20', String(Date.now())); } catch (e) {}
    ponCookie('lgchat_addons20', '1', 365);
  }

  var cargado = false, cuponAuto = false, ocupado = false, cerrada = false, bloqueado = false, temporizador = null;

  function abajo() { lista.scrollTop = lista.scrollHeight; }
  function burbuja(rol, texto) {
    var b = el('div', 'lgc-msg ' + (rol === 'visitante' ? 'lgc-visitante' : 'lgc-asesor'));
    if (rol === 'visitante') b.textContent = texto; else b.innerHTML = md(texto);
    lista.appendChild(b); abajo(); return b;
  }
  function aviso(texto, botones) {
    var a = el('div', 'lgc-aviso');
    if (texto) a.appendChild(el('div', '', esc(texto)));
    if (botones) {
      var bs = el('div', 'lgc-botones');
      botones.forEach(function (b) {
        var x = el('button', 'lgc-boton' + (b.sec ? ' lgc-sec' : ''), esc(b.t));
        x.type = 'button';
        x.onclick = function () { a.remove(); b.f(); };
        bs.appendChild(x);
      });
      a.appendChild(bs);
    }
    lista.appendChild(a); abajo(); return a;
  }
  function activa(si) { caja.disabled = !si; botonEnviar.disabled = !si; if (si && !cuponAuto && !window.matchMedia('(max-width: 480px)').matches) caja.focus(); }
  function saludo() {
    var esModulo = /product|collection/.test(raiz.dataset.tipo || '');
    burbuja('asesor', cuponAuto ? T.cupon : esModulo ? T.holaModulo : T.hola);
  }

  // Cierre por inactividad: se puede retomar desde el propio chat.
  function programaCierre() {
    clearTimeout(temporizador);
    if (bloqueado) return;
    temporizador = setTimeout(cierraSesion, INACTIVIDAD);
  }
  function cierraSesion() {
    if (ocupado || bloqueado || cerrada) return;
    cerrada = true; activa(false);
    aviso(T.cerrada, [{ t: T.retomar, f: retoma }]);
  }
  function retoma() {
    cerrada = false;
    lista.innerHTML = '';
    cargaSesion(true);
  }

  function post(ruta, datos) {
    return fetch(API + ruta, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(datos) });
  }

  function pinta(mensajes) {
    mensajes.forEach(function (m) { burbuja(m.rol, m.texto); });
  }

  // Al abrir: si la conversación sigue viva (menos de 2 min), se sigue; si no, se ofrece retomarla.
  function cargaSesion(forzarRetomar) {
    cargado = true;
    if (!conv) { saludo(); activa(true); actividad(); return; }
    activa(false);
    post('/sesion', { conv: conv }).then(function (r) { return r.json(); }).then(function (s) {
      if (s.bloqueado) { pinta(s.mensajes || []); bloquea(); return; }
      if (!s.conv || !s.mensajes.length) { conv = s.conv || ''; if (!conv) borraCookie('lgchat_id'); saludo(); activa(true); actividad(); return; }
      if (forzarRetomar || Date.now() - ultima() < INACTIVIDAD) {
        pinta(s.mensajes); activa(true); actividad(); return;
      }
      aviso(T.anterior, [
        { t: T.retomar, f: function () { pinta(s.mensajes); activa(true); actividad(); } },
        { t: T.nueva, sec: true, f: function () { conv = ''; borraCookie('lgchat_id'); saludo(); activa(true); actividad(); } }
      ]);
    }).catch(function () { saludo(); activa(true); });
  }

  // Móvil: el panel ocupa lo que deja el teclado (visualViewport) y la página de detrás no se mueve.
  var movil = window.matchMedia('(max-width: 480px)');
  function ajustaMovil() {
    if (!movil.matches || panel.hidden) { panel.style.height = ''; panel.style.top = ''; return; }
    var vv = window.visualViewport;
    if (vv) { panel.style.height = vv.height + 'px'; panel.style.top = vv.offsetTop + 'px'; }
    abajo();
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', ajustaMovil);
    window.visualViewport.addEventListener('scroll', ajustaMovil);
  }
  function bloqueaScroll(si) { document.documentElement.classList.toggle('lgc-sin-scroll', si && movil.matches); }

  function abre() {
    panel.hidden = false; lanzador.hidden = true;
    bloqueaScroll(true); ajustaMovil();
    try { sessionStorage.setItem('lgchat_abierto', '1'); } catch (e) {}
    if (!cargado) cargaSesion(false); else if (!cerrada && !bloqueado && !movil.matches) caja.focus();
  }
  function cierra() {
    panel.hidden = true; lanzador.hidden = false;
    bloqueaScroll(false); ajustaMovil();
    try { sessionStorage.removeItem('lgchat_abierto'); } catch (e) {}
  }
  lanzador.onclick = abre;
  panel.querySelector('.lgc-cerrar').onclick = cierra;

  // ---- formulario fijo (bloqueo o fallo) ----
  function formulario(texto) {
    activa(false);
    var f = el('form', 'lgc-form');
    f.innerHTML = '<div>' + esc(texto) + '</div>' +
      '<input name="nombre" maxlength="120" required placeholder="' + esc(T.nombre) + '">' +
      '<input name="email" type="email" maxlength="200" required placeholder="' + esc(T.email) + '">' +
      '<input name="telefono" maxlength="40" placeholder="' + esc(T.tel) + '">' +
      '<textarea name="mensaje" rows="3" maxlength="2000" required placeholder="' + esc(T.necesidad) + '"></textarea>' +
      '<input name="web" class="lgc-trampa" tabindex="-1" autocomplete="off" aria-hidden="true">' +
      '<div class="lgc-error" hidden></div>' +
      '<button type="submit" class="lgc-boton">' + esc(T.enviar) + '</button>';
    f.onsubmit = function (ev) {
      ev.preventDefault();
      var d = { conv: conv, pagina: location.href, atrib: atrib() };
      ['nombre', 'email', 'telefono', 'mensaje', 'web'].forEach(function (k) { d[k] = f.elements[k].value.trim(); });
      var err = f.querySelector('.lgc-error');
      if (!d.nombre || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email) || !d.mensaje) { err.textContent = T.invalido; err.hidden = false; return; }
      f.querySelector('button').disabled = true;
      post('/contacto', d).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        f.replaceWith(el('div', 'lgc-msg lgc-asesor', md(T.gracias)));
      }).catch(function () { err.textContent = T.invalido; err.hidden = false; f.querySelector('button').disabled = false; });
    };
    lista.appendChild(f); abajo();
  }
  function bloquea() {
    bloqueado = true; clearTimeout(temporizador); activa(false);
    form.hidden = true;
    formulario(T.bloqueo);
  }

  // ---- enviar y leer la respuesta a trozos (SSE sobre fetch) ----
  function contexto() {
    return { tipo: raiz.dataset.tipo || '', titulo: raiz.dataset.titulo || document.title, url: location.href.split('#')[0], idioma: idioma, producto: raiz.dataset.producto || '', coleccion: raiz.dataset.coleccion || '',
      campana: CAMPANA ? 'addons20' : '', modulo: MODULO, cupon_visto: CAMPANA && cuponVisto() };
  }
  // Procedencia para el CRM: la de lg-atribucion.js de la web; sin él, la URL completa y el referrer.
  var entrada = location.href;
  function atrib() {
    try { var a = window.lgAtribucion ? window.lgAtribucion.campos() : null; if (a) return a; } catch (e) {}
    return { landing_page_url: entrada, referrer_url: document.referrer || null };
  }
  function envia(texto) {
    if (ocupado || bloqueado || cerrada) return;
    ocupado = true; activa(false); actividad();
    burbuja('visitante', texto);
    var b = el('div', 'lgc-msg lgc-asesor lgc-escribiendo', '<span></span><span></span><span></span>');
    lista.appendChild(b); abajo();
    var acumulado = '', fallo = '';
    function evento(nombre, dato) {
      var v; try { v = JSON.parse(dato); } catch (e) { v = dato; }
      if (nombre === 'conv') { conv = v; ponCookie('lgchat_id', conv, 365); }
      else if (nombre === 't') {
        if (!acumulado) b.classList.remove('lgc-escribiendo');
        acumulado += v; b.innerHTML = md(acumulado); abajo();
      } else if (nombre === 'bloqueo') { if (!acumulado) b.remove(); bloquea(); }
      else if (nombre === 'error') fallo = v || 'error';
    }
    post('/mensaje', { conv: conv, texto: texto, pagina: contexto(), atrib: atrib() }).then(function (r) {
      if (!r.ok || !r.body) throw new Error(r.status);
      var lector = r.body.getReader(), dec = new TextDecoder(), buf = '';
      function lee() {
        return lector.read().then(function (x) {
          if (x.done) return;
          buf += dec.decode(x.value, { stream: true });
          var partes = buf.split('\n\n'); buf = partes.pop();
          partes.forEach(function (p) {
            var n = '', d = '';
            p.split('\n').forEach(function (l) {
              if (l.indexOf('event: ') === 0) n = l.slice(7);
              else if (l.indexOf('data: ') === 0) d += l.slice(6);
            });
            if (n) evento(n, d);
          });
          return lee();
        });
      }
      return lee();
    }).catch(function () { fallo = 'red'; }).then(function () {
      ocupado = false;
      if (bloqueado) return;
      if (fallo || !acumulado) {
        b.classList.remove('lgc-escribiendo');
        b.innerHTML = md(fallo === 'ocupado' ? T.ocupado : T.error);
        if (fallo !== 'ocupado') { formulario(T.bloqueo); return; }
      }
      if (CAMPANA && /ADDONS20/i.test(acumulado)) ofreceCupon('pregunta');
      activa(true); actividad();
    });
  }
  form.onsubmit = function (ev) {
    ev.preventDefault();
    var t = caja.value.trim();
    if (!t) return;
    caja.value = ''; caja.style.height = '';
    envia(t);
  };
  caja.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && !ev.shiftKey) { ev.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.onsubmit(ev); }
  });
  caja.addEventListener('input', function () { caja.style.height = 'auto'; caja.style.height = Math.min(caja.scrollHeight, 110) + 'px'; });

  try { if (sessionStorage.getItem('lgchat_abierto')) abre(); } catch (e) {}

  // ---- invitación: si lleva un rato en la página sin hacer nada, el asesor saluda con una
  // burbuja junto al botón. Una vez al día como mucho y nunca a quien ya ha usado el chat. ----
  var QUIETO = 40 * 1000;
  var invitacion = null, reloj = null;
  function puedeInvitar() { return panel.hidden && !leeCookie('lgchat_id') && !leeCookie('lgchat_inv'); }
  function quitaInvitacion() { if (invitacion) { invitacion.remove(); invitacion = null; } }
  // Mientras esté a la vista el aviso de cookies de Shopify, no se le pone nada encima.
  function avisoCookies() {
    var b = document.getElementById('shopify-pc__banner');
    return !!(b && b.getBoundingClientRect().height > 0 && getComputedStyle(b).visibility !== 'hidden');
  }
  function invita() {
    if (!puedeInvitar()) return;
    if (avisoCookies()) { rearma(); return; }
    ponCookie('lgchat_inv', '1', 1);
    var esModulo = /product|collection/.test(raiz.dataset.tipo || '');
    invitacion = el('div', 'lgc-invitacion');
    invitacion.setAttribute('role', 'status');
    invitacion.innerHTML = '<button type="button" class="lgc-inv-texto">' + esc(esModulo ? T.holaModulo : T.hola) + '</button>' +
      '<button type="button" class="lgc-inv-cerrar" aria-label="' + esc(T.cerrar) + '">×</button>';
    invitacion.querySelector('.lgc-inv-texto').onclick = function () { quitaInvitacion(); abre(); };
    invitacion.querySelector('.lgc-inv-cerrar').onclick = quitaInvitacion;
    raiz.insertBefore(invitacion, lanzador);
    pararReloj();
  }
  function rearma() { clearTimeout(reloj); reloj = setTimeout(invita, QUIETO); }
  var EVENTOS = ['mousemove', 'scroll', 'keydown', 'touchstart', 'click'];
  function pararReloj() { clearTimeout(reloj); EVENTOS.forEach(function (e) { window.removeEventListener(e, rearma, true); }); }
  if (puedeInvitar()) {
    EVENTOS.forEach(function (e) { window.addEventListener(e, rearma, { capture: true, passive: true }); });
    rearma();
  }
  // Página de un módulo: a los 2 min el asesor se abre solo para recordar el cupón, una vez por
  // visitante. Nunca a quien ya ha chateado, con el chat abierto o encima del aviso de cookies.
  // En móvil no se tapa la página: sale la burbuja junto al botón. Tampoco si el popup del cupón de la
  // web ya salió en esta visita (lg_addons20_popup) ni a navegadores automatizados, bots o agentes.
  var AUTOMATA = navigator.webdriver === true ||
    /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|preview|python|curl|wget|httpclient|axios|node-fetch|playwright|puppeteer|selenium|phantom|gpt|openai|claude|anthropic|perplexity|bytespider|ccbot|cohere|diffbot|agent/i.test(navigator.userAgent || '');
  function popupVisto() { try { return sessionStorage.getItem('lg_addons20_popup') === '1'; } catch (e) { return false; } }
  var APERTURA = /[?&]lgc_demo=cupon/.test(location.search) ? 5000 : 2 * 60 * 1000; // ?lgc_demo=cupon para probarlo
  function abreCupon() {
    if (!panel.hidden || leeCookie('lgchat_id') || cuponVisto() || popupVisto()) return;
    if (avisoCookies()) { setTimeout(abreCupon, 15000); return; }
    marcaCupon(); quitaInvitacion(); pararReloj();
    ofreceCupon('apertura');
    if (movil.matches) {
      invitacion = el('div', 'lgc-invitacion');
      invitacion.setAttribute('role', 'status');
      invitacion.innerHTML = '<button type="button" class="lgc-inv-texto">' + md(T.cupon) + '</button>' +
        '<button type="button" class="lgc-inv-cerrar" aria-label="' + esc(T.cerrar) + '">×</button>';
      invitacion.querySelector('.lgc-inv-texto').onclick = function () { quitaInvitacion(); cuponAuto = true; abre(); };
      invitacion.querySelector('.lgc-inv-cerrar').onclick = quitaInvitacion;
      raiz.insertBefore(invitacion, lanzador);
      return;
    }
    // Abierto solo no cuenta como abierto por el visitante: no le sigue por las páginas.
    cuponAuto = true; abre();
    try { sessionStorage.removeItem('lgchat_abierto'); } catch (e) {}
  }
  if (CAMPANA && MODULO && !AUTOMATA && !leeCookie('lgchat_id') && !cuponVisto()) setTimeout(abreCupon, APERTURA);

  var abreAntes = lanzador.onclick;
  lanzador.onclick = function () { quitaInvitacion(); pararReloj(); abreAntes(); };
})();
